import { history } from "../../src/index";

import * as types from '../constants/decisiondetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as decisiondetailsApi from '../api/decisiondetails';

export function resetDecision() {
    // console.log("resetCustomer action call");
    return dispatch => {
        dispatch({ type: types.FETCH_DECISION_RESET });
    }
}

export function setDecisionDetails(data) {
    // console.log("getDecisionDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_DECISION_REQUEST_COMPLETED, data: data });
    }
}

export function getDecisionStatusLookupDetails() {
    // console.log("getDecisionLookupDetails action call");
    return (dispatch, getState) => {
        // console.log('teamDetails', getState())
        let _state = getState()
        if (_state && _state.decisionDetails && _state.decisionDetails.decisionlookup && _state.decisionDetails.decisionlookup.length > 0) {
            // console.log('getDecisionStatusLookupDetails loaded from CACHE')
        }
        else {
            dispatch({ type: types.FETCH_DECISION_LOOKUP_REQUEST });
            decisiondetailsApi.getDecisionStatusLookups()
                .then(function (response) {
                    // console.log("getDecisionDetails", response)
                    dispatch({ type: types.FETCH_DECISION_LOOKUP_REQUEST_COMPLETED, data: response.data });
                })
                .catch(function (err) {
                    // console.log("getDecisionDetails Error", err)
                    dispatch({ type: types.FETCH_DECISION_LOOKUP_REQUEST_ERROR });
                });
        }
    }
}

export function getDecisionDetails(id) {
    // console.log("getDecisionDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_DECISION_REQUEST });
        decisiondetailsApi.getDecision(id)
            .then(function (response) {
                // console.log("getDecisionDetails", response)
                dispatch({ type: types.FETCH_DECISION_REQUEST_COMPLETED, data: response.data ? response.data[0] : null });
            })
            .catch(function (err) {
                // console.log("getDecisionDetails Error", err)
                dispatch({ type: types.FETCH_DECISION_REQUEST_ERROR });
            });
    }
}

export function getDecisionDetailsList(committee_id) {
    // console.log("getDecisionDetailsList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_DECISION_LIST_REQUEST });
        decisiondetailsApi.getDecisionList(committee_id)
            .then(function (response) {
                // console.log("getDecisionDetailsList", response)
                dispatch({ type: types.FETCH_DECISION_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getDecisionDetailsList Error", err)
                dispatch({ type: types.FETCH_DECISION_LIST_REQUEST_ERROR });
            });
    }
}

export function addDecisionDetails(objModel) {
    // console.log("addDecisionDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_DECISION_REQUEST });
        decisiondetailsApi.addDecision(objModel)
            .then(function (response) {
                // console.log("addDecisionDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_DECISION_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                    history.push('/decision/decision-list/' + objModel.undercommittee_val);
                }
                dispatch({ type: types.ADD_DECISION_RESET });
            })
            .catch(function (err) {
                // console.log("addDecisionDetails action err", err)
                dispatch({ type: types.ADD_DECISION_REQUEST_ERROR });
            });
    }
}

export function updateDecisionDetails(objModel) {
    // console.log("updateDecisionDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_DECISION_REQUEST });
        decisiondetailsApi.updateDecision(objModel)
            .then(function (response) {
                // console.log("updateDecisionDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_DECISION_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    history.push('/decision/decision-list/' + objModel.undercommittee_val);
                }
                dispatch({ type: types.ADD_DECISION_RESET });
            })
            .catch(function (err) {
                // console.log("updateDecisionDetails action err", err)
                dispatch({ type: types.ADD_DECISION_REQUEST_ERROR });
            });
    }
}

export function updateSubDecisionDetails(objModel) {
    // console.log("updateDecisionDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_DECISION_REQUEST });
        decisiondetailsApi.updateSubDecision(objModel)
            .then(function (response) {
                // console.log("updateDecisionDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_DECISION_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    // history.push('/decision/decision-list/' + objModel.undercommittee_val);
                }
                dispatch({ type: types.ADD_DECISION_RESET });
            })
            .catch(function (err) {
                // console.log("updateDecisionDetails action err", err)
                dispatch({ type: types.ADD_DECISION_REQUEST_ERROR });
            });
    }
}

export function deleteDecisionDetails(objModel) {
    // console.log("deleteDecisionDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_DECISION_REQUEST });
        decisiondetailsApi.deleteDecision(objModel)
            .then(function (response) {
                // console.log("deleteDecisionDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_DECISION_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                    history.push('/decision/decision-list');
                }
                dispatch({ type: types.ADD_DECISION_RESET });
            })
            .catch(function (err) {
                // console.log("deleteDecisionDetails action err", err)
                dispatch({ type: types.ADD_DECISION_REQUEST_ERROR });
            });
    }
}

export function deleteSubDecisionDetails(objModel, decision_id) {
    // console.log("deleteSubDecisionDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_DECISION_REQUEST });
        decisiondetailsApi.deleteSubDecision(objModel)
            .then(function (response) {
                // console.log("deleteSubDecisionDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_DECISION_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                    // history.push('/decision/add-decision/' + decision_id);
                }
                dispatch({ type: types.ADD_DECISION_RESET });
            })
            .catch(function (err) {
                // console.log("deleteSubDecisionDetails action err", err)
                dispatch({ type: types.ADD_DECISION_REQUEST_ERROR });
            });
    }
}



// WEBPACK FOOTER //
// ./actions/decisiondetails.js